import * as React from "react";
import Header from "./Header";
import Submission from "../submissions/Submission";
import ApplicantRegistrationForm from "../submissions/ApplicantRegistrationForm";
import ApplicantContinue from "../submissions/ApplicantContinue";
import EntityRegistrationForm from "../submissions/EntityRegistrationForm";
import EntityContinue from "../submissions/EntityContinue";
import { ApplicantSessionProvider } from "../submissions/applicantSession";

export default function LayoutSubmission({ type }) {
  return (
    // El proveedor envuelve también al Header: es así como le llegan el nombre y
    // la foto de quien se resolvió — el aspirante o, en las pantallas de
    // entidades, la razón social y el logo. La sesión pública es la misma cosa
    // en los dos casos (una identidad sin Firebase Auth), así que comparten el
    // contexto en vez de tener uno cada una.
    <ApplicantSessionProvider>
      <Header />
      {type === "home" && <Submission />}
      {type === "profile" && <ApplicantRegistrationForm />}
      {type === "continuar" && <ApplicantContinue />}
      {type === "entity-profile" && <EntityRegistrationForm />}
      {type === "entity-continuar" && <EntityContinue />}
    </ApplicantSessionProvider>
  );
}
